import { Platform } from '@angular/cdk/platform';
import { Component, Inject, OnDestroy, OnInit, Input } from '@angular/core';
import { DOCUMENT } from '@angular/common';
//import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FuseConfigService } from './@fuse/services/config.service';
import { FuseNavigationService } from './@fuse/components/navigation/navigation.service';
import { FuseSidebarService } from './@fuse/components/sidebar/sidebar.service';
import { FuseSplashScreenService } from './@fuse/services/splash-screen.service';
//import { FuseTranslationLoaderService } from './@fuse/services/translation-loader.service';

// import { navigation } from './navigation/navigation';
// import { locale as navigationEnglish } from './navigation/i18n/en';
// import { locale as navigationTurkish } from './navigation/i18n/tr';
import { NavigationProvider} from '@ecap3/core';
@Component({
    selector   : 'fuse-main',
    templateUrl: './atlas.component.html',
    styleUrls  : ['./atlas.component.scss']
})
export class FuseMainComponent implements OnInit, OnDestroy
{
    @Input() bannerComponent : any;
    @Input() toolbarComponent : any;
    @Input() footerComponent : any;
    @Input() quickPanelComponent: any;
    @Input() chatPanelComponent:any;
    @Input() sidePanelComponent:any;
    @Input() appList:any;
    fuseConfig: any;
    //navigation: any;
    @Input() navigations: any[];
    // Private
    private _unsubscribeAll: Subject<void>;

    /**
     * Constructor
     *
     * param {DOCUMENT} document
     * param {FuseConfigService} _fuseConfigService
     * param {FuseNavigationService} _fuseNavigationService
     * param {FuseSidebarService} _fuseSidebarService
     * param {FuseSplashScreenService} _fuseSplashScreenService
     * param {FuseTranslationLoaderService} _fuseTranslationLoaderService
     * param {Platform} _platform
     * param {TranslateService} _translateService
     */
    constructor(
        @Inject(DOCUMENT) private document: any,
        private _fuseConfigService: FuseConfigService,
        private _fuseNavigationService: FuseNavigationService,
        private _fuseSidebarService: FuseSidebarService,
        private _fuseSplashScreenService: FuseSplashScreenService,
        //private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        //private _translateService: TranslateService,
        private _platform: Platform,
        private navigationProvider: NavigationProvider,
    )
    {
        //console.log(this.footerComponent);
        // Get default navigation
        //this.navigation = navigation;

        //this._fuseNavigationService.unregister('main');
                // Set the main navigation as our current navigation


        // this.navigationProvider.getCurrentNavigationObserable().subscribe((response)=>{

        //     if(response.length>0){
        //         // Register the navigation to the service
        //         this._fuseNavigationService.register('main', response);

        //         // Set the main navigation as our current navigation
        //         this._fuseNavigationService.setCurrentNavigation('main');
        //         this._fuseNavigationService.unregister('main');
        //     }
        // })


        // Add languages
        //this._translateService.addLangs(['en', 'tr']);

        // Set the default language
        //this._translateService.setDefaultLang('en');

        // Set the navigation translations
        //this._fuseTranslationLoaderService.loadTranslations(navigationEnglish, navigationTurkish);

        // Use a language
        //this._translateService.use('en');

        // Add is-mobile class to the body if the platform is mobile
        if ( this._platform.ANDROID || this._platform.IOS )
        {
            this.document.body.classList.add('is-mobile');
        }

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // this.navigationProvider.assignNavigationsVisibility();
        // this._fuseNavigationService.register('main', this.navigations);
        // this._fuseNavigationService.setCurrentNavigation('main');
        // // Subscribe to config changes
        // this._fuseConfigService.config
        //     .pipe(takeUntil(this._unsubscribeAll))
        //     .subscribe((config) => {
        //         this.fuseConfig = config;
        //         if ( this.fuseConfig.layout.width === 'boxed' )
        //         {
        //             this.document.body.classList.add('boxed');
        //         }
        //         else
        //         {
        //             this.document.body.classList.remove('boxed');
        //         }
        //     });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null as any);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * param key
     */
    toggleSidebarOpen(key): void
    {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }
}
